var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-bar'),_c('app-navigation-drawer'),_c('v-main',{staticClass:"main-container",class:{ 'white-background': !_vm.$route.meta.fullScreen }},[_c('router-view')],1),_c('pickup-alert-overlay')],1)}
var staticRenderFns = []

export { render, staticRenderFns }